import { __awaiter } from 'tslib';
import { getRecaptchaToken, getCreatorsRecaptchaToken } from '../recaptcha.js';

const ENDPOINT = 'REGISTERuser';
function registerUser(gateway, params = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        let token;
        try {
            token = yield getRecaptchaToken('register');
        }
        catch (error) { }
        return gateway.post(registerUser.endpoint, Object.assign(Object.assign({}, params), { re_token: token }), Object.assign(Object.assign({}, params), { re_token: token }));
    });
}
registerUser.endpoint = ENDPOINT;
function dashboardRegisterUser(gateway, params = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        let token;
        try {
            token = yield getCreatorsRecaptchaToken('register');
        }
        catch (error) { }
        return gateway.post(dashboardRegisterUser.endpoint, Object.assign(Object.assign({}, params), { re_token: token }), Object.assign(Object.assign({}, params), { dashboardaccess: 'yes', re_token: token }), '', null, 'json');
    });
}
dashboardRegisterUser.endpoint = ENDPOINT;

export { dashboardRegisterUser, registerUser };
//# sourceMappingURL=registerUser.js.map
